// ----for active of variants without loading------------
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.select-radio input[type="radio"]').forEach(function(radio){

    radio.addEventListener('change', function(){

      const group = radio.closest('.nutty-wrapper') || document;

      group.querySelectorAll('.select-radio label').forEach(function(label){
        label.classList.remove('checked-brd');
      });

      radio.closest('label').classList.add('checked-brd');

    });

  });

});
